import React, { JSX, useEffect, useState } from 'react';
import { useMsal } from '@azure/msal-react';
import { useCurrentUser } from '../auth/useCurrentUser';
import { apiClient } from './httpClient';
import { loginRequest } from '../../authConfig';
import { AuthenticationResult } from '@azure/msal-browser';

interface RequestInterceptorProps {
    children: JSX.Element,
}

const RequestInterceptor: React.FC<RequestInterceptorProps> = ({ children }: RequestInterceptorProps) => {
    const { instance } = useMsal();
    const { account } = useCurrentUser();
    const [isReady, setIsReady] = useState(false);

    useEffect(() => {
        const interceptorId = apiClient.interceptors.request.use(async (config) => {
            if (!account) {
                throw Error('No active account! Verify a user has been signed in.');
            }

            const response: AuthenticationResult = await instance.acquireTokenSilent({
                ...loginRequest,
                account,
            });

            const bearer = `Bearer ${response.accessToken}`;
            config.headers.Authorization = bearer;

            return config;
        });

        setIsReady(true);

        return () => {
            apiClient.interceptors.request.eject(interceptorId);
        };
    }, [account, instance]);

    // Child effects may send requests as soon as they mount.
    if (!isReady) return null;
    
    return (
        <>
            {children}
        </>
    );
};

export default RequestInterceptor;
